import GlobalStyle from "../../../styles/GlobalStyle";
import { V2ReportStyle } from "../../../styles/V2ReportStyle";

const DotWithText = ({
  borderColor,
  backgroundColor,
  title,
}: {
  borderColor?: string;
  backgroundColor?: string;
  title?: string;
}) => {
  return (
    <div style={{ ...V2ReportStyle.flexRowCenter, gap: 5 }}>
      <div
        style={{
          ...V2ReportStyle.dot,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 1, // Added to ensure the border is visible on web
          borderStyle: "solid", // Required for the border to render
        }}
      />
      <span style={{ ...GlobalStyle.blackBoldText, fontSize: "1.8rem" }}>
        {title}
      </span>
    </div>
  );
};

export default DotWithText;
